module.exports = __webpack_public_path__ + "static/media/npr.81458a44.svg";